import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import "./Vendor_Rating_Modal.css";
import { postData } from "../../../utils/api";
import ModalSave from "../ModelSave";

const Vendor_Rating_Modal = (props) => {
  const [rating, setRating] = useState(0);

  // console.log("rating:", rating);

  const [hover, setHover] = useState(null);
  const [review, setReview] = useState("");

  const resetForm = () => {
    setRating(0);
    setHover(null);
    setReview("");
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleSave = async () => {
    const response = await postData(`/vendor/rating/${props.id}`, {
      rating: rating,
    });

    if (response?.success) {
      setShowModal({ code: response.code, message: response.message });
      setTimeout(() => {
        setShowModal(0);
        props.onHide();
      }, 2000);

      resetForm(); // ✅ reset here

      props.getDataAll();
      props.onHide();
    }
  };

  return (
    <section className="Rating_Modal modal-holder">
      <Modal
        {...props}
        size="md"
        centered
        className="Rating_Modal modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>Give Rating</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {/* ⭐ Star Rating */}
          <div className="star-container">
            {[...Array(5)].map((star, index) => {
              const ratingValue = index + 1;

              return (
                <FaStar
                  key={index}
                  size={35}
                  className="star"
                  color={ratingValue <= (hover || rating) ? "#ffc107" : "#ccc"}
                  onClick={() => setRating(ratingValue)}
                  onMouseEnter={() => setHover(ratingValue)}
                  onMouseLeave={() => setHover(null)}
                />
              );
            })}
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-center gap-3 mt-4">
            <Button
              className="cancle_btn btn_holder"
              onClick={() => {
                resetForm();
                props.onHide();
              }}
            >
              Cancel
            </Button>
            <Button
              className="save_btn btn_holder"
              onClick={handleSave}
              disabled={rating === 0}
            >
              Save
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </section>
  );
};

export default Vendor_Rating_Modal;
